type RichParagraphsProps = {
  text?: string;
  className?: string;
};

const lineBreakRegex = /[\r\n\r|\n|]/;

function RichParagraphs({ text, className }: RichParagraphsProps) {
  if (!text) return null;

  const textLines = text.split(lineBreakRegex);

  return (
    <p className={className}>
      {textLines.map((line, index) => {
        return (
          <span key={index}>
            {line}
            <br />
          </span>
        );
      })}
    </p>
  );
}

export { RichParagraphs };
